// Translations
import form from '../sections/form/translations/en'

// Translation: Password change > Landing (English)
export default Object.freeze({
	sections: { form }
})
